import { render, staticRenderFns } from "./CustomModalTemplate.vue?vue&type=template&id=12f7e816"
import script from "./CustomModalTemplate.vue?vue&type=script&lang=js"
export * from "./CustomModalTemplate.vue?vue&type=script&lang=js"
import style0 from "./CustomModalTemplate.vue?vue&type=style&index=0&id=12f7e816&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports